import styled from 'styled-components';
import { BiuRoundedButton } from '../../biu-web-components/src/components';

export const NoResultView = styled.div`
height: 100vh;
width: 100%;
display:flex;
justify-content:center;
align-items:center;
`
export const LoadingButton = styled(BiuRoundedButton)<any>`
	margin-right: ${({ direction }: any) =>
		direction === 'rtl' ? '24px' : 'unset'};
	margin-left: ${({ direction }: any) =>
		direction === 'rtl' ? 'unset' : '24px'};
	
	.biu-rounded-button__icon {
		animation-name: rotation;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
	}

    @keyframes rotation {
        0% { transform:rotate(0deg); }
        100% { transform:rotate(360deg); }
    }
`;
